import { Phone, Mail } from "lucide-react";
import { COMPANY } from "@/data/content";

export default function MobileStickyCTA() {
  return (
    <div
      className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white border-t border-slate-200 px-3 py-2 flex gap-2"
      data-testid="mobile-sticky-cta"
    >
      <a
        href={`tel:${COMPANY.phoneRaw}`}
        className="flex-1 inline-flex items-center justify-center gap-2 bg-[#0C2749] text-white text-sm font-medium py-3 rounded-sm"
        data-testid="mobile-cta-call"
      >
        <Phone className="w-4 h-4" /> Anruf
      </a>
      <a
        href={`mailto:${COMPANY.email}`}
        className="flex-1 inline-flex items-center justify-center gap-2 bg-[#2873B8] text-white text-sm font-medium py-3 rounded-sm"
        data-testid="mobile-cta-email"
      >
        <Mail className="w-4 h-4" /> E-Mail
      </a>
    </div>
  );
}
